import createRoute  from '@widesk-ui/tools/createRoute';
import ProductModel from '@models/shop/ProductModel';

export default createRoute.splitView('/entertainments/:entertainmentId/products', 'shop', 'ProductSplitView', ProductModel.localize('plural'));
